import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, VStack } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { CypressIds } from '../../../constants/cypressIds';
import { hideModal } from '../../../redux/modules/modal';

const StackedButtonGroup = ({
  label = 'Confirm',
  secondaryLabel = 'Cancel',
  primaryButtonVariant = 'gradientSuccess',
  onClick = () => {},
  secondaryClick,
  dataAnalyticsId = '',
  dusk = undefined,
  isDisabled = false,
  isLoading = false,
  loadingText = '',
  secondaryDisabled = false,
  ...rest
}) => {
  const dispatch = useDispatch();
  const close = () => dispatch(hideModal());
  const secondClick = secondaryClick || close;

  return (
    <VStack height="inherit" width="100%">
      <Button
        isRound
        data-analytics-id={dataAnalyticsId}
        data-cy={CypressIds.stackedButtonPrimaryOption}
        dusk={dusk}
        isDisabled={isDisabled}
        isLoading={isLoading}
        loadingText={loadingText}
        size="lg"
        variant={primaryButtonVariant}
        width="180px"
        onClick={onClick}
        {...rest}
      >
        {label}
      </Button>
      <Button
        data-cy={CypressIds.stackedButtonSecondaryOption}
        isDisabled={secondaryDisabled}
        variant="textGrey"
        onClick={secondClick}
      >
        {secondaryLabel}
      </Button>
    </VStack>
  );
};

StackedButtonGroup.propTypes = {
  /** Text displayed on main button. Defaults to 'Confirm' */
  label: PropTypes.string,
  /** Text displayed on secondary button. Defaults to 'Cancel' */
  secondaryLabel: PropTypes.string,
  /** Event handler for main/confirm button */
  onClick: PropTypes.func,
  /** Event handler for cancel button. Defaults to `() => dispatch(hideModal())` */
  secondaryClick: PropTypes.func,
  /** Analytics tracking id for main button */
  dataAnalyticsId: PropTypes.string,
  /** Regression testing id for main button */
  dusk: PropTypes.string,
  /** button variant for main button */
  primaryButtonVariant: PropTypes.string,
  /** Disable main button */
  isDisabled: PropTypes.bool,
  /** Disable and show loading spinner on main button */
  isLoading: PropTypes.bool,
  /** If loading is true and loadingText is provided, text will appear to the right of the spinner.
   * Without loading text, spinner will render in the middle of button */
  loadingText: PropTypes.string,
  secondaryDisabled: PropTypes.bool,
  cypressId: PropTypes.string
};

export default StackedButtonGroup;
